var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-7.2 -7.2 38.40 38.40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.2,
    y: -7.2,
    width: 38.4,
    height: 38.4,
    rx: 19.2,
    fill: "#1c244c ",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C8.44771 4 8 4.44772 8 5V7H6.5C6.04113 7 5.64115 7.3123 5.52985 7.75746L4.21922 13H0.999997C0.668173 13 0.35796 13.1646 0.17193 13.4394C-0.0141001 13.7141 -0.0517159 14.0633 0.0715204 14.3714L2.07152 19.3714C2.22338 19.751 2.59109 20 3 20H20C20.4 20 20.7616 19.7616 20.9191 19.3939L23.9191 12.3939C24.0516 12.085 24.0199 11.7301 23.8348 11.4495C23.6498 11.1689 23.3361 11 23 11H19.8828L19.4923 7.87597C19.4297 7.37554 19.0043 7 18.5 7H15V5C15 4.44772 14.5523 4 14 4H9ZM11.382 13H6.28077L7.28077 9H17.6172L17.8672 11H14.2361C13.0997 11 12.0609 11.642 11.5528 12.6584L11.382 13ZM13.3416 13.5528C13.511 13.214 13.8573 13 14.2361 13H19H21.4835L19.3406 18H3.67703L2.47703 15H5H11.382C12.1395 15 12.832 14.572 13.1708 13.8944L13.3416 13.5528Z",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.491b6f0e2efe448f1d223e0dc7efa5b1.svg";
export { ForwardRef as ReactComponent };